import seloUrl from "../../../assets/images/selo-2030-10mil.png";
import { UploadImageIcon } from "../../../assets/UploadImageIcon";
import { useState, useRef } from "react";
import api from "../../../services/api";
import { getImageUrl } from "../../../utils/media";
import "./style.css";

export default function Proposito({ proposito, visao, editMode, onError, onChange }) {

  const fileInputRef = useRef(null);
  const [seloPreview, setSeloPreview] = useState(null);

  const seloImageSrc = seloPreview || getImageUrl(visao?.image) || seloUrl;
 
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
 
    const previewUrl = URL.createObjectURL(file);
    setSeloPreview(previewUrl);
 
    try {
 
      const formData = new FormData();
      formData.append("image", file);
 
      const response = await api.post("/media/upload", formData);
 
      setSeloPreview(response.data.url);
      onChange("vision", "image", response.data);
    } catch (error) {
      setSeloPreview(null);
      onError(error);
    } finally {
      URL.revokeObjectURL(previewUrl);
    }
  };


  if (editMode) {
    return (
      <section className="proposito">
        <div className="proposito__bloco">
          <input
            className="quem-somos-page-h2__input"
            value={proposito?.title || ""}
            onChange={(e) => onChange("purpose", "title", e.target.value)}
          />
          <textarea
            className="quem-somos-page-p__textarea"
            value={proposito?.text || ""}
            onChange={(e) => onChange("purpose", "text", e.target.value)}
          />
        </div>

        <div className="proposito__bloco proposito__bloco--visao">
          <div className="proposito__visao-texto">
            <input
              className="quem-somos-page-h2__input"
              value={visao?.title || ""}
              onChange={(e) => onChange("vision", "title", e.target.value)}
            />
            <textarea
              className="quem-somos-page-p__textarea"
              value={visao?.text || ""}
              onChange={(e) => onChange("vision", "text", e.target.value)}
            />
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",
              border: "solid 2px #3759A5", borderRadius: "7px", height: "150px" }} 
            className="proposito__selo" aria-hidden="true">
            <img src={seloImageSrc} alt="" className="proposito__selo-img" />
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />
              <button
                type="button"
                className="upload-image-btn"
                onClick={() => fileInputRef.current.click()}
                title="Substituir imagem atual"
              >
                <UploadImageIcon />
              </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="proposito">
      <div className="proposito__bloco">
        <h2 className="proposito__titulo">{proposito?.title || "Propósito"}</h2>
        <p className="proposito__texto">{proposito?.text ?? ""}</p>
      </div>

      <div className="proposito__bloco proposito__bloco--visao">
        <div className="proposito__visao-texto">
          <h2 className="proposito__titulo">{visao?.title || "Visão"}</h2>
          <p className="proposito__texto">{visao?.text ?? ""}</p>
        </div>

        <div className="proposito__selo" aria-hidden="true">
          <img src={getImageUrl(visao?.image) || seloUrl} alt="" className="proposito__selo-img" />
        </div>
      </div>
    </section>
  );
}
